/* unplugin-vue-components disabled */import script from "./PBStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PBStatus.vue?vue&type=script&setup=true&lang=js"

import "./PBStatus.vue?vue&type=style&index=0&id=75d42c25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d42c25"]])

export default __exports__